module.exports = __webpack_public_path__ + "img/engagement_goutte_eau.0217e0be.png";